import { useState } from 'react';


const Utf8EncoderDecoder = () => {
  const [inputValue, setInputValue] = useState('');
  const [encodedValue, setEncodedValue] = useState('');
  const [decodedValue, setDecodedValue] = useState('');


  const handleEncode = () => {
    const encoder = new TextEncoder();
    const encoded = encoder.encode(inputValue);
    setEncodedValue(Array.from(encoded).map((x) => x.toString()).join(' '));
  };

  const handleDecode = () => {
    const decoder = new TextDecoder('utf-8');
    const decoded = decoder.decode(new Uint8Array(inputValue.split(' ').map((x) => parseInt(x))));
    setDecodedValue(decoded);
  };

      const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label
  
  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


  
  const handleClear = () => {
    setInputValue('');
    setEncodedValue('');
    setDecodedValue('');
  };

      // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(inputValue);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <div className="row">
        <div className="col-md-4 mb-4">
          <label className="form-label" htmlFor="input-value">Input:</label>
          <textarea
            id="input-value"
            className="form-control"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            rows={10}
          />
          <div className="mt-2">
            <button
              className="btn btn-primary me-2"
              onClick={handleEncode}
            >
            Encode
            </button>
            <button
              className="btn btn-primary"
              onClick={handleDecode}
            >
              Decode
            </button>
            <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <label className="form-label" htmlFor="encoded-value">Encoded:</label>
          <textarea
            id="encoded-value"
            className="form-control"
            value={encodedValue}
            rows={10}
            readOnly
          />
          <button
            className="btn btn-primary mt-2"
            onClick={() => handleCopy(encodedValue)}
          >
                {copyButtonLabel}

          </button>
        </div>
        <div className="col-md-4 mb-4">
          <label className="form-label" htmlFor="decoded-value">Decoded:</label>
          <textarea
            id="decoded-value"
            className="form-control"
            value={decodedValue}
            rows={10}
            readOnly
          />
          <button
            className="btn btn-primary mt-2"
            onClick={() => handleCopy(decodedValue)}
          >
                 {copyButtonLabel}

          </button>
          
        </div>
      </div>

    <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
</div>

  );
};

export default Utf8EncoderDecoder;